module.exports = __webpack_public_path__ + "img/7.a1fbd6e8.png";